// extracted by mini-css-extract-plugin
export var hidden = "_v4-0";